import React from 'react';
import edapWrapper from '@homeaway/edap-wrapper';

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        let hasError = false;

        try {
            if (localStorage) {
                localStorage.setItem('oneTapReady', 'true');
            }
        } catch (e) {
            hasError = true;
            edapWrapper().push({
                name: 'generic.event',
                data: {
                    eventaction: 'googleonetap.error',
                    eventcategory: 'googleonetap',
                    eventlabel: 'cookiesDisabled',
                },
            });
        }
        this.state = {hasError};
    }

    componentDidCatch() {
        // Nothing to do for now, we should probably log events to the server - knotty integration?
    }

    render() {
        if (this.state.hasError) {
            return null;
        }
        return this.props.children;
    }
}

export default ErrorBoundary;
